/**
 * Ratchet brand mark v2 — modernist monogram.
 *
 * Variants:
 *   - default:        Cobalt tile + white R (use on dark surfaces)
 *   - mono:           Monochrome white (no tile) for tight nav usage
 *   - wordmark:       Mark + "RATCHET" wordmark beside it (horizontal)
 *   - spinning prop:  Rotates the mark — use while AI is processing
 */
function MonoMark({ size, spinClass, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} ${spinClass}`}
      aria-label="Ratchet"
      role="img"
    >
      <g fill="currentColor">
        <rect x="12" y="10" width="6" height="28" />
        <rect x="12" y="10" width="22" height="6" />
        <rect x="28" y="10" width="6" height="16" />
        <rect x="12" y="20" width="22" height="6" />
        <path d="M 22 24 L 28 24 L 38 42 L 32 42 Z" />
      </g>
    </svg>
  );
}

function DefaultMark({ size, spinClass, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} ${spinClass}`}
      aria-label="Ratchet"
      role="img"
    >
      <rect width="48" height="48" fill="#0066FF" />
      <g fill="#FFFFFF">
        <rect x="12" y="10" width="6" height="28" />
        <rect x="12" y="10" width="22" height="6" />
        <rect x="28" y="10" width="6" height="16" />
        <rect x="12" y="20" width="22" height="6" />
        <path d="M 22 24 L 28 24 L 38 42 L 32 42 Z" />
      </g>
    </svg>
  );
}

export default function RatchetLogo({ size = 28, className = "", variant = "default", spinning = false }) {
  const spinClass = spinning ? "animate-spin-slow" : "";

  if (variant === "wordmark") {
    return (
      <span className={`inline-flex items-center gap-2 ${className}`} aria-label="Ratchet" role="img">
        <DefaultMark size={size} spinClass={spinClass} className="" />
        <span className="font-display font-black tracking-tighter" style={{ fontSize: size * 0.78, lineHeight: 1 }}>
          RATCHET
        </span>
      </span>
    );
  }

  if (variant === "mono") {
    return <MonoMark size={size} spinClass={spinClass} className={className} />;
  }

  return <DefaultMark size={size} spinClass={spinClass} className={className} />;
}
